(() => {
  'use strict';
  function init() {
    const root = document.querySelector('[data-global-activity-bar]');
    if (!root || root.dataset.ready) return;
    const activityDataSource = window.activityDataSource;
    const entries = activityDataSource?.entries;
    if (!Array.isArray(entries) || !entries.length) return;
    root.dataset.ready = 'true';
    root.dataset.source = activityDataSource.source;
    const message = root.querySelector('[data-activity-message]');
    const time = root.querySelector('[data-activity-time]');
    const inner = root.querySelector('.global-activity-bar__inner');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    function render(entry) {
      const customer = document.createElement('span');
      customer.textContent = entry.masked_customer + '님이 ';
      const product = document.createElement('strong');
      product.textContent = entry.product_title.replace(/\s+(오\s*드\s*(?:뚜왈렛|퍼퓸)|오데토일렛|오드퍼퓸).*$/, '').replace(/\s+\d+\s*(?:ml|g|oz)$/i, '');
      const suffix = document.createElement('span');
      const last = product.textContent.charCodeAt(product.textContent.length - 1);
      const particle = last >= 0xAC00 && last <= 0xD7A3 && (last - 0xAC00) % 28 === 0 ? '를' : '을';
      suffix.textContent = particle + ' 주문했어요';
      message.replaceChildren(customer, product, suffix);
      const minutes = Number(entry.relative_minutes);
      time.textContent = '· ' + (minutes < 60 ? minutes + '분 전' : Math.floor(minutes / 60) + '시간 전');
      root.dataset.activityId = entry.id;
      root.dataset.source = entry.source;
      root.setAttribute('aria-label', entry.source === 'test' ? '테스트 구매 알림' : '최근 구매 알림');
    }
    render(entries[index]);
    let timer;
    let deadline = performance.now() + 4000;
    function schedule() {
      timer = setTimeout(() => {
        if (!root.isConnected) return;
        if (reduced.matches) {
          render(entries[index = (index + 1) % entries.length]);
          deadline += 4000;
          schedule();
          return;
        }
        inner.classList.add('is-leaving');
        timer = setTimeout(() => {
          render(entries[index = (index + 1) % entries.length]);
          inner.classList.remove('is-leaving');
          inner.classList.add('is-entering');
          requestAnimationFrame(() => requestAnimationFrame(() => inner.classList.remove('is-entering')));
          deadline += 4000;
          schedule();
        }, 160);
      }, Math.max(0, deadline - performance.now() - (reduced.matches ? 0 : 160)));
    }
    schedule();
    window.addEventListener('pagehide', () => clearTimeout(timer), {once: true});
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      clearTimeout(timer);
      inner.classList.remove('is-leaving', 'is-entering');
      deadline = performance.now() + 4000;
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
